<template>
  <div class="quality_inspection">
    <el-divider content-position="left">续费质检列表</el-divider>
    <div style="display: flex">
      <el-select
        v-model="searchForm.companyId"
        filterable
        remote
        reserve-keyword
        placeholder="请输入公司名称筛选公司"
        size="mini"
        clearable
        :remote-method="searchRemoteCompanyMethodS"
        :loading="searchLoading"
        @change="toSearch"
      >
        <el-option
          v-for="searchCompany in searchCompaniesx"
          :key="searchCompany.id"
          :label="searchCompany.company_name"
          :value="searchCompany.id"
        >
        </el-option>
      </el-select>
      <el-popover placement="bottom" width="600" trigger="click" v-model="visible">
        <el-form
          ref="searchForm"
          :model="searchForm"
          label-width="100px"
          style="padding-right: 0.23rem"
          class="search"
        >
          <div style="display: inline-block; width: 320px">
            <div style="text-align: center; margin-left: 100px">查询反馈过的人员</div>
            <el-form-item label="业务员" prop="business">
              <el-cascader
                style="width: 100%"
                v-model="searchForm.business"
                placeholder="请选择反馈过的业务员"
                :options="businessOptions"
                size="mini"
                @visible-change="loadAdminBus"
                :props="{ expandTrigger: 'hover', emitPath: false }"
                clearable
                filterable
                :filter-method="filterOptions"
              >
              </el-cascader>
              
            </el-form-item>
            <el-form-item label="客服会计" prop="kefu">
              <el-cascader
                style="width: 100%"
                v-model="searchForm.kefu"
                placeholder="请选择反馈过的客服会计"
                :options="kefuOptions"
                size="mini"
                @click.native="loadAdminKefu"
                :props="{ expandTrigger: 'hover', emitPath: false }"
                clearable
                filterable
                :filter-method="filterOptions"
              >
              </el-cascader>
              
            </el-form-item>
            <el-form-item label="理票会计" prop="jizhang">
              <el-cascader
                style="width: 100%"
                v-model="searchForm.jizhang"
                placeholder="请选择反馈过的理票会计"
                :options="jizhangOptions"
                size="mini"
                @click.native="loadAdminJizhang"
                :props="{ expandTrigger: 'hover', emitPath: false }"
                clearable
                filterable
                :filter-method="filterOptions"
              >
              </el-cascader>
            </el-form-item>
            <el-form-item label="记账报税会计" prop="tax">
              <el-cascader
                style="width: 100%"
                v-model="searchForm.tax"
                placeholder="请选择反馈过的记账报税会计"
                :options="taxOptions"
                size="mini"
                @click.native="loadAdminTax"
                :props="{ expandTrigger: 'hover', emitPath: false }"
                clearable
                filterable
                :filter-method="filterOptions"
              >
              </el-cascader>
            
            </el-form-item>
            <el-form-item label="开票会计" prop="kaipiao">
              <el-cascader
                style="width: 100%"
                v-model="searchForm.kaipiao"
                placeholder="请选择反馈过的开票会计"
                :options="kaipiaoOptions"
                size="mini"
                @click.native="loadAdminKaipiao"
                :props="{ expandTrigger: 'hover', emitPath: false }"
                clearable
                filterable
                :filter-method="filterOptions"
              >
              </el-cascader>
              
            </el-form-item>
            <el-form-item label="财税负责人" prop="leader">
              <el-cascader
                style="width: 100%"
                v-model="searchForm.leader"
                placeholder="请选择反馈过的财税负责人"
                :options="leaderOptions"
                size="mini"
                @click.native="loadAdminLeader"
                :props="{ expandTrigger: 'hover', emitPath: false }"
                clearable
                filterable
                :filter-method="filterOptions"
              >
              </el-cascader>
              
            </el-form-item>
            <el-form-item label="公司其他人员" prop="qita">
              <el-cascader
                style="width: 100%"
                v-model="searchForm.qita"
                placeholder="请选择反馈过的公司其他人员"
                :options="qitaOptions"
                size="mini"
                @click.native="loadAdminQita"
                :props="{ expandTrigger: 'hover', emitPath: false }"
                clearable
                filterable
                :filter-method="filterOptions"
              >
              </el-cascader>
              
            </el-form-item>
            <el-form-item label="到期月份" prop="month">
              <el-date-picker
                v-model="searchForm.month"
                type="month"
                placeholder="选择月份"
                size="mini"
                value-format="yyyy-MM"
                style="width: 100%"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="反馈时间" prop="feedback_at">
              <!-- <el-date-picker
              v-model="searchForm.feedback_at"
              type="month"
              placeholder="选择月份"
              size="mini"
              value-format="yyyy-MM"
              style="width: 100%"
            >
            </el-date-picker> -->
              <el-date-picker
                v-model="searchForm.feedback_at"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="rangePickerOptions"
                :default-time="['00:00:00', '23:59:59']"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 100%"
                size="mini"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="存在问题" prop="is_problem">
              <el-radio-group
                v-model="searchForm.is_problem"
                size="mini"
                @change="searchIfNoraml"
              >
                <el-radio-button :label="'0'">否</el-radio-button>
                <el-radio-button :label="1">是</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="" prop="ifNormal" v-if="searchForm.is_problem === '0'">
              <el-checkbox v-model="searchForm.ifNormal" size="mini"
                >客户表达正常续费</el-checkbox
              >
            </el-form-item>
            <el-form-item label="" prop="cancelOrLost" v-if="searchForm.is_problem === 1">
              <el-radio v-model="searchForm.cancelOrLost" label="c"
                >客户表达注销</el-radio
              >
              <el-radio v-model="searchForm.cancelOrLost" label="l">流失预警</el-radio>
              <el-radio v-model="searchForm.cancelOrLost" label="q">确认流失</el-radio>
            </el-form-item>
            <!-- <el-form-item
            label="问题类型"
            prop="categoryId"
            v-if="searchForm.is_problem === 1"
          >
            <el-select
              v-model="searchForm.categoryId"
              multiple
              placeholder="请选择"
              clearable
              filterable
              size="mini"
              style="width: 100%"
              @clik.native="getSearchProblemOptions"
            >
              <el-option
                v-for="item in problemOptions"
                :key="item.id"
                :label="item.category_name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item> -->
            <el-form-item
              label="责任人"
              prop="incharge"
              v-if="searchForm.is_problem === 1"
            >
              <el-cascader
                style="width: 100%"
                v-model="searchForm.incharge"
                placeholder="请选择责任人"
                :options="searchInchargeOptions"
                size="mini"
                @click.native="getSearchInchargeOptions"
                :props="{ expandTrigger: 'hover', emitPath: false }"
                clearable
                filterable
                :filter-method="filterOptions"
              >
              </el-cascader>
              
            </el-form-item>
            <el-form-item
              label="ETA处理时间"
              prop="done_at"
              v-if="searchForm.is_problem === 1"
            >
              <el-date-picker
                v-model="searchForm.done_at"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="searchRangePickerOptions"
                :default-time="['00:00:00', '23:59:59']"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 100%"
                size="mini"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="其他" prop="other">
              <el-checkbox-group v-model="searchForm.other" size="mini">
                <el-checkbox label="zero" border>未提出续费建议的公司</el-checkbox>
                <!-- <el-checkbox label="备选项2" border></el-checkbox> -->
              </el-checkbox-group>
            </el-form-item>
            <!-- <el-form-item label="采纳案例" prop="is_use">
            <el-radio-group v-model="searchForm.is_use" size="mini">
              <el-radio-button :label="1">是</el-radio-button>
              <el-radio-button :label="'0'">否</el-radio-button>
            </el-radio-group>
          </el-form-item> -->
          </div>
          <div style="display: inline-block; width: 260px; float: right">
            <div style="text-align: center">查询人员服务的公司</div>
            <el-form-item label-width="0" prop="businessC">
              <el-cascader
                style="width: 100%"
                v-model="searchForm.businessC"
                placeholder="选择业务员查询服务的公司"
                :options="businessOptionsC"
                size="mini"
                @visible-change="loadAdminBusC"
                :props="{ expandTrigger: 'hover', emitPath: false, multiple: true }"
                clearable
                filterable
                :filter-method="filterOptions"
              >
              </el-cascader>
              
            </el-form-item>
            <el-form-item label-width="0" prop="kefuC">
              <el-cascader
                style="width: 100%"
                v-model="searchForm.kefuC"
                placeholder="选择客服会计查询服务的公司"
                :options="kefuOptionsC"
                size="mini"
                @visible-change="loadAdminKefuC"
                :props="{ expandTrigger: 'hover', emitPath: false, multiple: true }"
                clearable
                filterable
                :filter-method="filterOptions"
              >
              </el-cascader>
            
            </el-form-item>
            <el-form-item label-width="0" prop="jizhangC">
              <el-cascader
                style="width: 100%"
                v-model="searchForm.jizhangC"
                placeholder="选择理票会计查询服务的公司"
                :options="jizhangOptionsC"
                size="mini"
                @visible-change="loadAdminJizhangC"
                :props="{ expandTrigger: 'hover', emitPath: false, multiple: true }"
                clearable
                filterable
                :filter-method="filterOptions"
              >
              </el-cascader>
              
            </el-form-item>
            <el-form-item label-width="0" prop="taxC">
              <el-cascader
                style="width: 100%"
                v-model="searchForm.taxC"
                placeholder="选择记账报税会计查询服务的公司"
                :options="taxOptionsC"
                size="mini"
                @visible-change="loadAdminTaxC"
                :props="{ expandTrigger: 'hover', emitPath: false, multiple: true }"
                clearable
                filterable
                :filter-method="filterOptions"
              >
              </el-cascader>
              
            </el-form-item>
            <el-form-item label-width="0" prop="kaipiaoC">
              <el-cascader
                style="width: 100%"
                v-model="searchForm.kaipiaoC"
                placeholder="选择开票会计查询服务的公司"
                :options="kaipiaoOptionsC"
                size="mini"
                @visible-change="loadAdminKaipiaoC"
                :props="{ expandTrigger: 'hover', emitPath: false, multiple: true }"
                clearable
                filterable
                :filter-method="filterOptions"
              >
              </el-cascader>
              
            </el-form-item>
            <el-form-item label-width="0" prop="leaderC">
              <el-cascader
                style="width: 100%"
                v-model="searchForm.leaderC"
                placeholder="选择财税负责人查询服务的公司"
                :options="leaderOptionsC"
                size="mini"
                @visible-change="loadAdminLeaderC"
                :props="{ expandTrigger: 'hover', emitPath: false, multiple: true }"
                clearable
                filterable
                :filter-method="filterOptions"
              >
              </el-cascader>
              
            </el-form-item>
            <el-form-item label-width="0">
              <div style="opacity: 0">111</div>
            </el-form-item>
            <el-form-item prop="serviceOvered" label="是否过期">
              <el-radio-group v-model="searchForm.serviceOvered" size="mini">
                <el-radio-button label="1">是</el-radio-button>
                <el-radio-button label="2">否</el-radio-button>
                <el-radio-button label="3">未知</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </div>
          <div style="text-align: right">
            <el-button type="info" @click="resetForm('searchForm')" size="mini"
              >重置</el-button
            >
            <el-button type="primary" @click="doSearch" size="mini">查询</el-button>
          </div>
        </el-form>
        <el-button slot="reference" size="mini" style="margin-left: 10px">筛选</el-button>
      </el-popover>
      <div style="text-align: right; flex: 1">
        <a href="/quains_cate">
          <el-button type="primary" size="mini">添加分类</el-button>
        </a>
      </div>
    </div>
    <el-collapse v-model="activeNames" style="border-top: none">
      <el-collapse-item title="" name="1">
        <template slot="title">
          <span style="color: #409eff">数据统计</span>
        </template>
        <el-row style="margin-top: 0.2rem; font-size: 0.38rem" :gutter="20">
          <el-col :span="3">
            <el-card style="border-left: 4px solid; border-radius: 0">
              <p>企业总数:</p>
              <p style="margin-top: 0.15rem">{{ total }}</p>
            </el-card>
          </el-col>
          <el-col :span="3">
            <el-card style="border-left: 4px solid #f56c6c; border-radius: 0">
              <p>已经过期:</p>
              <p style="color: #f56c6c; margin-top: 0.15rem">{{ overMonth }}</p>
            </el-card>
          </el-col>
          <el-col :span="3">
            <el-card style="border-left: 4px solid #e6a23c; border-radius: 0">
              <p>{{ monthsub1 }}月到期:</p>
              <p style="color: #e6a23c; margin-top: 0.15rem">{{ monthsub1Al }}</p>
            </el-card>
          </el-col>
          <el-col :span="3">
            <el-card style="border-left: 4px solid #e6a23c; border-radius: 0">
              <p>{{ month }}月到期:</p>
              <p style="color: #e6a23c; margin-top: 0.15rem">{{ monthAl }}</p>
            </el-card>
          </el-col>
          <el-col :span="3">
            <el-card style="border-left: 4px solid #67c23a; border-radius: 0">
              <p>{{ month1 }}月到期:</p>
              <p style="color: #67c23a; margin-top: 0.15rem">{{ month1Al }}</p>
            </el-card>
          </el-col>
          <el-col :span="3">
            <el-card style="border-left: 4px solid #409eff; border-radius: 0">
              <p>{{ month2 }}月到期:</p>
              <p style="color: #409eff; margin-top: 0.15rem">{{ month2Al }}</p>
            </el-card>
          </el-col>
          <el-col :span="3">
            <el-card style="border-left: 4px solid #409eff; border-radius: 0">
              <p>{{ month3 }}月到期:</p>
              <p style="color: #409eff; margin-top: 0.15rem">{{ month3Al }}</p>
            </el-card>
          </el-col>
          <el-col :span="3">
            <el-card style="border-left: 4px solid #409eff; border-radius: 0">
              <p>{{ month4 }}月到期:</p>
              <p style="color: #409eff; margin-top: 0.15rem">{{ month4Al }}</p>
            </el-card>
          </el-col>
        </el-row>
        <el-row style="margin-top: 0.2rem; font-size: 0.38rem" :gutter="20">
          <el-col :span="3">
            <el-card style="border-left: 4px solid; border-radius: 0">
              <p style="white-space: nowrap">本月已反馈:</p>
              <p style="margin-top: 0.15rem">{{ nowMonthAl }}</p>
            </el-card>
          </el-col>
          <el-col :span="3">
            <el-card style="border-left: 4px solid #409eff; border-radius: 0">
              <p style="white-space: nowrap">正常反馈:</p>
              <p style="color: #409eff; margin-top: 0.15rem">
                {{ nowMonthAlNor }}
              </p>
            </el-card>
          </el-col>
          <el-col :span="3">
            <el-card style="border-left: 4px solid #f56c6c; border-radius: 0">
              <p style="white-space: nowrap">存在问题:</p>
              <p style="color: #f56c6c; margin-top: 0.15rem">
                {{ nowMonthAlPro }}
              </p>
            </el-card>
          </el-col>
          <el-col :span="3">
            <el-card style="border-left: 4px solid #e6a23c; border-radius: 0">
              <p style="white-space: nowrap">流失预警:</p>
              <p style="color: #e6a23c; margin-top: 0.15rem">{{ lsyj }}</p>
            </el-card>
          </el-col>
          <el-col :span="3">
            <el-card style="border-left: 4px solid #f56c6c; border-radius: 0">
              <p style="white-space: nowrap">表达注销:</p>
              <p style="color: #f56c6c; margin-top: 0.15rem">{{ bdzx }}</p>
            </el-card>
          </el-col>
          <el-col :span="3">
            <el-card style="border-left: 4px solid #f56c6c; border-radius: 0">
              <p style="white-space: nowrap">确认流失:</p>
              <p style="color: #f56c6c; margin-top: 0.15rem">{{ qrls }}</p>
            </el-card>
          </el-col>
        </el-row>
        <el-row style="margin-top: 0.2rem; font-size: 0.38rem" :gutter="20">
          <el-col :span="4">
            <el-card style="border-left: 4px solid #67c23a; border-radius: 0">
              <p style="white-space: nowrap">存在问题已完成:</p>
              <p style="color: #67c23a; margin-top: 0.15rem">
                {{ nowMonthAlProAl }}
              </p>
            </el-card>
          </el-col>
          <el-col :span="4">
            <el-card style="border-left: 4px solid #409eff; border-radius: 0">
              <p style="white-space: nowrap">存在问题进行中:</p>
              <p style="color: #409eff; margin-top: 0.15rem">
                {{ nowMonthAlProIng }}
              </p>
            </el-card>
          </el-col>
          <el-col :span="4">
            <el-card style="border-left: 4px solid #e6a23c; border-radius: 0">
              <p style="white-space: nowrap">存在问题暂停:</p>
              <p style="color: #e6a23c; margin-top: 0.15rem">
                {{ nowMonthAlProPause }}
              </p>
            </el-card>
          </el-col>
        </el-row>
      </el-collapse-item>
    </el-collapse>
    <el-drawer
      title="录入"
      :visible.sync="categoryIndrawer"
      :direction="direction"
      :before-close="handleCloseIn"
      size="40%"
    >
      <div style="padding: 0rem 0.2rem; margin-top: -17px">
        <el-form
          :model="categoryForm"
          :rules="rules"
          ref="categoryForm"
          label-width="100px"
        >
          <el-form-item label="公司名称" prop="companyId">
            <span style="font-size: 0.28rem">{{ quains_company_name }}</span>
          </el-form-item>
          <el-form-item label="检查描述" prop="describe">
            <el-input
              size="mini"
              type="textarea"
              v-model="categoryForm.describe"
            ></el-input>
          </el-form-item>
          <el-form-item label="是否存在问题" prop="problem" style="margin-bottom: 0.1rem">
            <el-radio-group
              v-model="categoryForm.problem"
              size="mini"
              @change="ifProblem"
            >
              <el-radio-button :label="'0'">否</el-radio-button>
              <el-radio-button :label="1">是</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="" prop="ifNormal" v-if="categoryForm.problem === '0'">
            <el-checkbox v-model="categoryForm.ifNormal" size="mini"
              >客户表达正常续费</el-checkbox
            >
          </el-form-item>
          <el-form-item label="" prop="cancelOrLost" v-if="categoryForm.problem === 1">
            <el-radio v-model="categoryForm.cancelOrLost" label="c"
              >客户表达注销</el-radio
            >
            <el-radio v-model="categoryForm.cancelOrLost" label="l">流失预警</el-radio>
            <el-radio v-model="categoryForm.cancelOrLost" label="q">确认流失</el-radio>
          </el-form-item>
          <el-form-item
            label="问题类型"
            prop="categoryId"
            v-if="categoryForm.problem === 1"
          >
            <el-select
              v-model="categoryForm.categoryId"
              multiple
              placeholder="请选择"
              clearable
              filterable
              size="mini"
              style="width: 100%"
            >
              <el-option
                v-for="item in problemOptions"
                :key="item.id"
                :label="item.category_name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="责任人" prop="incharge" v-if="categoryForm.problem === 1">
            <el-select
              v-model="categoryForm.incharge"
              placeholder="请选择"
              clearable
              filterable
              size="mini"
              style="width: 100%"
            >
              <el-option
                v-for="item in inchargeOptions"
                :key="item.id"
                :label="'(' + item.role + ')' + item.username"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="ETA处理时间"
            prop="done_at"
            v-if="categoryForm.problem === 1"
          >
            <el-date-picker
              v-model="categoryForm.done_at"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="donePickerOptions"
              :default-time="['00:00:00', '23:59:59']"
              style="width: 100%"
              size="mini"
              value-format="yyyy-MM-dd HH:mm:ss"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="上传截图" prop="url">
            <el-upload
              action="https://weixin.qiyehuo.com/api/quains/upscr"
              :headers="header"
              multiple
              ref="uploadMutiple"
              list-type="picture-card"
              :file-list="fileList"
              :limit="limit"
              accept="image/jpeg,image/jpg,image/png"
              :before-upload="beforeAvatarUpload"
              :on-success="handleAvatarSuccess"
              :on-change="handleAvatarChange"
              :on-preview="handlePictureCardPreview"
              :on-remove="handleRemove"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
            <div style="margin-top: 0.2rem">
              <span
                ><i class="el-icon-s-opportunity" style="color: #fb894c"
                  >点击下方，Ctrl+v上传</i
                ></span
              >
            </div>
            <!-- <div id="preview" @paste="handlePaste">
              <el-input
                size="mini"
                type="textarea"
                placeholder="先点击此处 再按Ctrl+V 粘贴至此处"
                max="0"
              ></el-input>
            </div> -->
            <div
              id="preview"
              @paste="handlePaste"
              style="border: 3px dashed #409eff; border-radius: 15px; text-indent: 2em"
            >
              <span style="opacity: 0.5">先点击此处 再按Ctrl+V 粘贴至此处</span>
            </div>
            <el-dialog :visible.sync="dialogVisible" :modal="false">
              <img width="100%" :src="dialogImageUrl" alt="" />
            </el-dialog>
          </el-form-item>
          <div style="text-align: right">
            <el-button
              type="primary"
              size="mini"
              @click="submitForm('categoryForm')"
              style="margin-right: 0.8rem"
              >添加</el-button
            >
          </div>
        </el-form>
      </div>
    </el-drawer>
    <el-drawer
      title="聊天记录"
      :visible.sync="chatDrawer"
      direction="rtl"
      :before-close="handleChatBeforeClose"
      size="50%"
    >
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <chat :chatId="chatId" :chatName="chatCompany"></chat>
        </el-row>
      </div>
    </el-drawer>
    <el-drawer
      title="处理方案录入"
      :visible.sync="handleProblemDrawer"
      :direction="direction"
      :before-close="handleCloseProblem"
      size="40%"
    >
      <div style="padding: 0.2em 1.4em; margin-top: -17px; height: 690px; overflow: auto">
        <el-form
          :model="problemForm"
          :rules="rulesPro"
          ref="problemForm"
          label-width="100px"
        >
          <el-form-item label="处理方案" prop="case">
            <el-input size="mini" type="textarea" v-model="problemForm.case"></el-input>
          </el-form-item>
          <el-form-item label="处理结果" prop="resulat">
            <el-radio-group v-model="problemForm.resulat" size="mini">
              <el-radio-button :label="1">完成</el-radio-button>
              <el-radio-button :label="0">进行中</el-radio-button>
              <el-radio-button :label="2">暂停</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="上传截图" prop="url">
            <el-upload
              action="https://weixin.qiyehuo.com/api/quains/upscr"
              :headers="header"
              multiple
              ref="uploadMutiplePro"
              list-type="picture-card"
              :file-list="fileListPro"
              :limit="limit"
              accept="image/jpeg,image/jpg,image/png"
              :before-upload="beforeAvatarUpload"
              :on-success="handleAvatarSuccessPro"
              :on-change="handleAvatarChangePro"
              :on-preview="handlePictureCardPreviewPro"
              :on-remove="handleRemovePro"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
            <div style="margin-top: 0.2rem">
              <span
                ><i class="el-icon-s-opportunity" style="color: #fb894c"
                  >点击下方，Ctrl+v上传</i
                ></span
              >
            </div>
            <!-- <div id="preview" @paste="handlePaste">
              <el-input
                size="mini"
                type="textarea"
                placeholder="先点击此处 再按Ctrl+V 粘贴至此处"
                max="0"
              ></el-input>
            </div> -->
            <div
              id="preview"
              @paste="handlePastePro"
              style="border: 3px dashed #409eff; border-radius: 15px; text-indent: 2em"
            >
              <span style="opacity: 0.5">先点击此处 再按Ctrl+V 粘贴至此处</span>
            </div>
            <el-dialog :visible.sync="dialogVisiblePro" :modal="false">
              <img width="100%" :src="dialogImageUrlPro" alt="" />
            </el-dialog>
          </el-form-item>
          <div style="text-align: right">
            <el-button type="primary" size="mini" @click="submitFormPro('problemForm')"
              >添加</el-button
            >
          </div>
        </el-form>
      </div>
    </el-drawer>
    <el-drawer
      title="修改"
      :visible.sync="categoryEditDrawer"
      :direction="direction"
      :before-close="handleClose"
      size="40%"
    >
      <div style="padding: 0.2em 1.4em; margin-top: -17px">
        <el-form
          :model="categoryEditForm"
          :rules="rules"
          ref="categoryEditForm"
          label-width="100px"
        >
          <el-form-item label="公司名称" style="margin-top: -0.4rem">
            <span style="font-size: 0.28rem">{{ other.company_name }}</span>
          </el-form-item>
          <el-form-item label="月份" style="margin-top: -0.4rem">
            <span style="font-size: 0.25rem">{{ other.month }}</span>
          </el-form-item>
          <el-form-item label="分类名称" prop="categoryId" style="margin-top: -0.4rem">
            <!-- <el-select
              v-model="categoryEditForm.categoryId"
              filterable
              remote
              reserve-keyword
              placeholder="请输入搜索分类名称"
              size="mini"
              clearable
              :remote-method="searchRemoteCfbodyEdit"
              :loading="searchLoading"
              style="width: 100%"
            >
              <el-option
                v-for="searchCompany in searchEditBodies"
                :key="searchCompany.id"
                :label="searchCompany.category_name"
                :value="searchCompany.id"
              >
              </el-option>
            </el-select> -->
            <el-select
              size="mini"
              v-model="categoryEditForm.categoryId"
              clearable
              placeholder="请选择分类"
              style="width: 100%"
              @click.native="getCateEdit"
              filterable
            >
              <el-option
                v-for="item in cateEditOptions"
                :key="item.id"
                :label="item.category_name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="建议内容" prop="body">
            <el-input
              size="mini"
              type="textarea"
              v-model="categoryEditForm.body"
            ></el-input>
          </el-form-item>
          <el-form-item label="上传截图" prop="url">
            <el-upload
              action="https://weixin.qiyehuo.com/api/quains/upscr"
              :headers="header"
              multiple
              ref="editUploadMutiple"
              list-type="picture-card"
              :file-list="editFileList"
              :limit="limit"
              accept="image/jpeg,image/jpg,image/png"
              :before-upload="beforeAvatarUpload"
              :on-success="editHandleAvatarSuccess"
              :on-change="editHandleAvatarChange"
              :on-preview="editHandlePictureCardPreview"
              :on-remove="editHandleRemove"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
            <div style="margin-top: 0.2rem">
              <span
                ><i class="el-icon-s-opportunity" style="color: #fb894c"
                  >点击下方，Ctrl+v上传</i
                ></span
              >
            </div>
            <!-- <div id="preview" @paste="handlePaste">
              <el-input
                size="mini"
                type="textarea"
                placeholder="先点击此处 再按Ctrl+V 粘贴至此处"
                max="0"
              ></el-input>
            </div> -->
            <div
              id="previewE"
              @paste="editHandlePaste"
              style="border: 3px dashed #409eff; border-radius: 15px; text-indent: 2em"
            >
              <span style="opacity: 0.5">先点击此处 再按Ctrl+V 粘贴至此处</span>
            </div>
            <el-dialog :visible.sync="dialogVisibleE" :modal="false">
              <img width="100%" :src="dialogImageUrlE" alt="" />
            </el-dialog>
          </el-form-item>
          <div style="text-align: right">
            <el-button
              type="primary"
              size="mini"
              @click="editSubmitForm('categoryEditForm')"
              >修改</el-button
            >
          </div>
        </el-form>
      </div>
    </el-drawer>
    <el-drawer
      title="企业微信聊天记录"
      :visible.sync="wxChatDrawer"
      direction="rtl"
      :before-close="handleWxChatBeforeClose"
      size="50%"
    >
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <wx-work-chat
            :chatId="wxWorkChatId"
            :chatName="wxWorkchatCompany"
          ></wx-work-chat>
        </el-row>
      </div>
    </el-drawer>
    <el-drawer
      title="电话联系记录"
      :visible.sync="callLogsDrawer"
      direction="rtl"
      :before-close="handleCallLogsBeforeClose"
      size="50%"
    >
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <call-logs
            :company="company"
            :phone="callPhone"
            :phone1="callPhone1"
            :phone2="callPhone2"
            :phone3="callPhone3"
          ></call-logs>
        </el-row>
      </div>
    </el-drawer>
    <el-drawer :visible.sync="normalDrawer" :direction="direction" size="40%">
      <template slot="title">
        <span style="font-size: 0.33rem; color: #409eff; font-weight: bold"
          >正常反馈</span
        >
      </template>
      <div style="padding: 0.2em 1.4em">
        <el-table
          :data="normalData"
          style="width: 100%; margin-top: 10px"
          border
          size="mini"
          :header-cell-style="{
            background: '#ecf4ff',
            color: '#333',
            fontWeight: '900',
            fontSize: '0.28rem',
          }"
        >
          <!-- <el-table-column
            prop="company_name"
            label="公司名称"
            width="250"
            fixed="left"
          >
            <template slot-scope="scope">
              <el-link
                style="color: #409eff; font-size: 0.28rem; cursor: pointer"
                @click="openCompanyCom(scope.row)"
              >
                {{ scope.row.company_name }}
              </el-link>
            </template>
          </el-table-column> -->
          <!-- <el-table-column
            prop="fin_table.end_time"
            label="到期时间"
            width="100"
            fixed="left"
          >
            <template slot-scope="scope">
              <div
                style="font-size: 0.28rem"
                v-if="scope.row.fin_table && scope.row.fin_table.end_time"
              >
                {{ scope.row.fin_table.end_time }}
              </div>
              <div v-else>未知</div>
            </template>
          </el-table-column> -->
          <el-table-column prop="checkner.username" label="反馈人" width="" fixed="left">
          </el-table-column>
          <el-table-column prop="created_at" label="反馈时间" width="" fixed="left">
          </el-table-column>
          <el-table-column prop="describe" label="反馈描述" width=""> </el-table-column>
          <el-table-column prop="" label="截图" width="">
            <template slot-scope="scope">
              <div style="padding-top: 0.18rem">
                <el-badge
                  :value="scope.row.quainsscreen.length"
                  v-if="scope.row.quainsscreen.length !== 0"
                >
                  <el-button
                    size="mini"
                    style="border: none"
                    @click="openScreen(scope.row.quainsscreen)"
                    >截图</el-button
                  >
                </el-badge>
                <el-badge
                  :value="scope.row.quainsscreen.length"
                  v-if="scope.row.quainsscreen.length === 0"
                >
                  <el-button size="mini" style="border: none; cursor: default" disabled
                    >截图</el-button
                  >
                </el-badge>
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="business" label="业务员" width="130">
            <template slot-scope="scope">
              <ul v-for="(item, index) in [scope.row.business]" :key="index">
                <li v-for="(i, key) in item" :key="i.id">
                  <span style="font-size: 0.28rem">
                    <i>{{ key + ":" }}</i>
                    <i style="margin-left: 0.2rem">{{ i.length }}</i>
                  </span>
                </li>
              </ul>
            </template>
          </el-table-column>
          <el-table-column prop="kefu" label="客服会计" width="130">
            <template slot-scope="scope">
              <ul v-for="(item, index) in [scope.row.kefu]" :key="index">
                <li v-for="(i, key) in item" :key="i.id">
                  <span style="font-size: 0.28rem">
                    <i>{{ key + ":" }}</i>
                    <i style="margin-left: 0.2rem">{{ i.length }}</i>
                  </span>
                </li>
              </ul>
            </template>
          </el-table-column>
          <el-table-column prop="jizhang" label="理票会计" width="130">
            <template slot-scope="scope">
              <ul v-for="(item, index) in [scope.row.jizhang]" :key="index">
                <li v-for="(i, key) in item" :key="i.id">
                  <span style="font-size: 0.28rem">
                    <i>{{ key + ":" }}</i>
                    <i style="margin-left: 0.2rem">{{ i.length }}</i>
                  </span>
                </li>
              </ul>
            </template>
          </el-table-column>
          <el-table-column prop="tax" label="记账报税会计" width="130">
            <template slot-scope="scope">
              <ul v-for="(item, index) in [scope.row.tax]" :key="index">
                <li v-for="(i, key) in item" :key="i.id">
                  <span style="font-size: 0.28rem">
                    <i>{{ key + ":" }}</i>
                    <i style="margin-left: 0.2rem">{{ i.length }}</i>
                  </span>
                </li>
              </ul>
            </template>
          </el-table-column>
          <el-table-column prop="kaipiao" label="开票会计" width="130">
            <template slot-scope="scope">
              <ul v-for="(item, index) in [scope.row.kaipiao]" :key="index">
                <li v-for="(i, key) in item" :key="i.id">
                  <span style="font-size: 0.28rem">
                    <i>{{ key + ":" }}</i>
                    <i style="margin-left: 0.2rem">{{ i.length }}</i>
                  </span>
                </li>
              </ul>
            </template>
          </el-table-column>
          <el-table-column prop="zuzhang" label="财税负责人" width="130">
            <template slot-scope="scope">
              <ul v-for="(item, index) in [scope.row.zuzhang]" :key="index">
                <li v-for="(i, key) in item" :key="i.id">
                  <span style="font-size: 0.28rem">
                    <i>{{ key + ":" }}</i>
                    <i style="margin-left: 0.2rem">{{ i.length }}</i>
                  </span>
                </li>
              </ul>
            </template>
          </el-table-column>
          <el-table-column prop="otherUser" label="公司其他人员" width="130">
            <template slot-scope="scope">
              <ul v-for="(item, index) in [scope.row.otherUser]" :key="index">
                <li v-for="(i, key) in item" :key="i.id">
                  <span style="font-size: 0.28rem">
                    <i>{{ key + ":" }}</i>
                    <i style="margin-left: 0.2rem">{{ i.length }}</i>
                  </span>
                </li>
              </ul>
            </template>
          </el-table-column> -->
        </el-table>
      </div>
    </el-drawer>
    <el-dialog :visible.sync="screenDialog" style="text-align: center">
      <div style="display: inline-block" v-for="item in screenDialogData" :key="item.id">
        <div style="padding: 0 0.15rem">
          <el-tooltip class="item" effect="dark" :content="item.name" placement="top">
            <span
              style="
                diplay: block;
                width: 2.5rem;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              "
              >{{ item.name }}</span
            >
          </el-tooltip>
          <el-avatar
            title="点击放大"
            shape="square"
            :size="150"
            fit="cover"
            :src="item.url"
            @click.native="reSizePic(item.url)"
            style="display: block; margin-top: 0.28rem; cursor: pointer"
          ></el-avatar>
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="reSizeDialog">
      <img width="100%" :src="this.reSizeUrl" />
    </el-dialog>
    <el-drawer :visible.sync="notNormalDrawer" :direction="direction" size="50%">
      <template slot="title">
        <span style="font-size: 0.33rem; color: #409eff; font-weight: bold"
          >存在问题反馈</span
        >
      </template>
      <div style="padding: 0.2em 1.4em">
        <el-table
          :data="notNormalData"
          style="width: 100%; margin-top: 10px"
          border
          size="mini"
          :header-cell-style="{
            background: '#ecf4ff',
            color: '#333',
            fontWeight: '900',
            fontSize: '0.28rem',
          }"
        >
          <el-table-column
            prop="checkner.username"
            label="反馈人"
            width="100"
            fixed="left"
          >
          </el-table-column>
          <el-table-column prop="created_at" label="反馈时间" width="160" fixed="left">
            <template slot-scope="scope">
              <el-tooltip
                class="item"
                effect="dark"
                content="点击查看处理详情"
                placement="top"
                v-if="scope.row.handle === 1"
              >
                <el-link
                  style="font-size: 0.28rem; color: #409eff"
                  @click="openHandleDetail(scope.row.id)"
                  >{{ scope.row.created_at }}</el-link
                >
              </el-tooltip>
              <span v-else>{{ scope.row.created_at }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="cateName" label="问题分类" width="140">
          </el-table-column>
          <el-table-column prop="handle" label="是否已处理" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.handle === 1">已处理</span>
              <span v-else>未处理</span>
            </template>
          </el-table-column>
          <el-table-column prop="incharge" label="责任人" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.incharge === null">无</span>
              <span v-else>{{ scope.row.incharge.username }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="doneat_start" label="ETA：责任处理时间" width="280">
            <template slot-scope="scope">
              <span v-if="scope.row.doneat_start === null && scope.row.doneat_end"
                >无</span
              >
              <span v-else>{{
                scope.row.doneat_start + "至" + scope.row.doneat_end
              }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="describe" label="反馈描述" width="180">
          </el-table-column>
          <el-table-column prop="" label="反馈截图" width="120">
            <template slot-scope="scope">
              <div style="padding-top: 0.18rem">
                <el-badge
                  :value="scope.row.quainsscreen.length"
                  v-if="scope.row.quainsscreen.length !== 0"
                >
                  <el-button
                    size="mini"
                    style="border: none"
                    @click="openScreen(scope.row.quainsscreen)"
                    >截图</el-button
                  >
                </el-badge>
                <el-badge
                  :value="scope.row.quainsscreen.length"
                  v-if="scope.row.quainsscreen.length === 0"
                >
                  <el-button size="mini" style="border: none; cursor: default" disabled
                    >截图</el-button
                  >
                </el-badge>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="case" label="处理方案" width="180"> </el-table-column>
          <el-table-column prop="resulat_view" label="处理结果" width="100">
          </el-table-column>
          <el-table-column prop="handler" label="处理人" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.handler">{{ scope.row.handler.username }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="handled_at" label="处理时间" width="150">
          </el-table-column>
          <el-table-column prop="" label="处理截图" width="120">
            <template slot-scope="scope">
              <div style="padding-top: 0.18rem">
                <el-badge
                  :value="scope.row.quainsproblemscreen.length"
                  v-if="scope.row.quainsproblemscreen.length !== 0"
                >
                  <el-button
                    size="mini"
                    style="border: none"
                    @click="openScreen(scope.row.quainsproblemscreen)"
                    >截图</el-button
                  >
                </el-badge>
                <el-badge
                  :value="scope.row.quainsproblemscreen.length"
                  v-if="scope.row.quainsproblemscreen.length === 0"
                >
                  <el-button size="mini" style="border: none; cursor: default" disabled
                    >截图</el-button
                  >
                </el-badge>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" fixed="right" width="100">
            <!-- <el-table-column label="编辑" align="center" > -->
            <template slot-scope="scope">
              <el-tooltip
                class="item"
                effect="dark"
                content="处理问题"
                placement="top"
                v-if="scope.row.handle === 0"
              >
                <el-button
                  @click.native.prevent="handleProblem(scope.row.id)"
                  type="primary"
                  size="mini"
                  icon="el-icon-s-management"
                  circle
                >
                </el-button>
              </el-tooltip>
              <el-tooltip
                class="item"
                effect="dark"
                content="问题已处理"
                placement="top"
                v-else
              >
                <el-button
                  @click.native.prevent="categoryIn(scope.row.id, scope.row.company_name)"
                  type="primary"
                  size="mini"
                  icon="el-icon-s-management"
                  circle
                  disabled
                >
                </el-button>
              </el-tooltip>
              <!-- <el-tooltip
              class="item"
              effect="dark"
              content="修改"
              placement="top"
            >
              <el-button
                @click.native.prevent="editRow(scope.$index, categoryData)"
                type="primary"
                size="mini"
                icon="el-icon-edit"
                circle
              >
              </el-button>
            </el-tooltip> -->
              <!-- categoryIn -->
              <!-- <el-tooltip
              class="item"
              effect="dark"
              content="删除"
              placement="top"
            >
              <el-button
                @click.native.prevent="deleteRow(scope.$index, categoryData)"
                type="danger"
                size="mini"
                icon="el-icon-delete"
                circle
              >
              </el-button>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              content="阅读记录"
              placement="top"
            >
              <el-button
                @click.native.prevent="readRow(scope.$index, categoryData)"
                type="success"
                size="mini"
                icon="el-icon-notebook-2"
                circle
              >
              </el-button>
            </el-tooltip> -->
            </template>
            <!-- </el-table-column> -->
            <!-- <el-table-column label="设为案例" align="center" fixed="right">
          <template slot-scope="scope">
            <el-radio-group
              v-model="ifuse[scope.$index]"
              size="mini"
              @change="setRow($event, scope.row)"
            >
              <el-radio-button :label="1">是</el-radio-button>
              <el-radio-button :label="'0'">否</el-radio-button>
            </el-radio-group>
          </template>
        </el-table-column> -->
          </el-table-column>
          <!-- <el-table-column prop="business" label="业务员" width="130">
            <template slot-scope="scope">
              <ul v-for="(item, index) in [scope.row.business]" :key="index">
                <li v-for="(i, key) in item" :key="i.id">
                  <span style="font-size: 0.28rem">
                    <i>{{ key + ":" }}</i>
                    <i style="margin-left: 0.2rem">{{ i.length }}</i>
                  </span>
                </li>
              </ul>
            </template>
          </el-table-column>
          <el-table-column prop="kefu" label="客服会计" width="130">
            <template slot-scope="scope">
              <ul v-for="(item, index) in [scope.row.kefu]" :key="index">
                <li v-for="(i, key) in item" :key="i.id">
                  <span style="font-size: 0.28rem">
                    <i>{{ key + ":" }}</i>
                    <i style="margin-left: 0.2rem">{{ i.length }}</i>
                  </span>
                </li>
              </ul>
            </template>
          </el-table-column>
          <el-table-column prop="jizhang" label="理票会计" width="130">
            <template slot-scope="scope">
              <ul v-for="(item, index) in [scope.row.jizhang]" :key="index">
                <li v-for="(i, key) in item" :key="i.id">
                  <span style="font-size: 0.28rem">
                    <i>{{ key + ":" }}</i>
                    <i style="margin-left: 0.2rem">{{ i.length }}</i>
                  </span>
                </li>
              </ul>
            </template>
          </el-table-column>
          <el-table-column prop="tax" label="记账报税会计" width="130">
            <template slot-scope="scope">
              <ul v-for="(item, index) in [scope.row.tax]" :key="index">
                <li v-for="(i, key) in item" :key="i.id">
                  <span style="font-size: 0.28rem">
                    <i>{{ key + ":" }}</i>
                    <i style="margin-left: 0.2rem">{{ i.length }}</i>
                  </span>
                </li>
              </ul>
            </template>
          </el-table-column>
          <el-table-column prop="kaipiao" label="开票会计" width="130">
            <template slot-scope="scope">
              <ul v-for="(item, index) in [scope.row.kaipiao]" :key="index">
                <li v-for="(i, key) in item" :key="i.id">
                  <span style="font-size: 0.28rem">
                    <i>{{ key + ":" }}</i>
                    <i style="margin-left: 0.2rem">{{ i.length }}</i>
                  </span>
                </li>
              </ul>
            </template>
          </el-table-column>
          <el-table-column prop="zuzhang" label="财税负责人" width="130">
            <template slot-scope="scope">
              <ul v-for="(item, index) in [scope.row.zuzhang]" :key="index">
                <li v-for="(i, key) in item" :key="i.id">
                  <span style="font-size: 0.28rem">
                    <i>{{ key + ":" }}</i>
                    <i style="margin-left: 0.2rem">{{ i.length }}</i>
                  </span>
                </li>
              </ul>
            </template>
          </el-table-column>
          <el-table-column prop="otherUser" label="公司其他人员" width="130">
            <template slot-scope="scope">
              <ul v-for="(item, index) in [scope.row.otherUser]" :key="index">
                <li v-for="(i, key) in item" :key="i.id">
                  <span style="font-size: 0.28rem">
                    <i>{{ key + ":" }}</i>
                    <i style="margin-left: 0.2rem">{{ i.length }}</i>
                  </span>
                </li>
              </ul>
            </template>
          </el-table-column> -->
        </el-table>
      </div>
    </el-drawer>
    <el-drawer :visible.sync="notNormalDrawerHandle" :direction="direction" size="50%">
      <template slot="title">
        <span style="font-size: 0.33rem; color: #409eff; font-weight: bold"
          >存在问题反馈处理详情</span
        >
      </template>
      <div style="padding: 0.2em 1.4em">
        <el-table
          :data="notNormalDataHandle"
          style="width: 100%; margin-top: 10px"
          border
          size="mini"
          :header-cell-style="{
            background: '#ecf4ff',
            color: '#333',
            fontWeight: '900',
            fontSize: '0.28rem',
          }"
        >
          <el-table-column prop="case" label="处理方案" width="180"> </el-table-column>
          <el-table-column prop="resulat_view" label="处理结果" width="100">
          </el-table-column>
          <el-table-column prop="handler" label="处理人" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.handler">{{ scope.row.handler.username }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="handled_at" label="处理时间" width="150">
          </el-table-column>
          <el-table-column prop="" label="处理截图" width="120">
            <template slot-scope="scope">
              <div style="padding-top: 0.18rem">
                <el-badge
                  :value="scope.row.quainsproblemscreen.length"
                  v-if="scope.row.quainsproblemscreen.length !== 0"
                >
                  <el-button
                    size="mini"
                    style="border: none"
                    @click="openScreen(scope.row.quainsproblemscreen)"
                    >截图</el-button
                  >
                </el-badge>
                <el-badge
                  :value="scope.row.quainsproblemscreen.length"
                  v-if="scope.row.quainsproblemscreen.length === 0"
                >
                  <el-button size="mini" style="border: none; cursor: default" disabled
                    >截图</el-button
                  >
                </el-badge>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-drawer>
    <el-drawer
      title="公司信息"
      :visible.sync="companyInfoDrawer"
      direction="rtl"
      size="50%"
    >
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <company-info :companyId="companyComId"></company-info>
        </el-row>
      </div>
    </el-drawer>

    <div class="middle-table">
      <el-table
        height="calc(100vh - 320px)"
        :data="categoryData"
        style="width: 100%"
        border
        size="mini"
        :header-cell-style="{
          background: '#ecf4ff',
          color: '#333',
          fontWeight: '900',
          fontSize: '0.28rem',
        }"
      >
        <el-table-column prop="company_name" label="公司名称" width="260" fixed="left">
          <template slot-scope="scope">
            <el-link
              style="color: #409eff; font-size: 0.28rem; cursor: pointer"
              @click="openCompanyCom(scope.row)"
            >
              {{ scope.row.company_name }}
            </el-link>
            <el-tooltip class="item" effect="dark" content="复制" placement="top"
              ><i
                class="el-icon-document-copy"
                style="margin-left: 0.1rem; cursor: pointer"
                @click="copySome(scope.row.company_name)"
              ></i
            ></el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
          prop="fin_table.end_time"
          label="到期时间"
          width="110"
          fixed="left"
        >
          <template slot-scope="scope">
            <div
              style="font-size: 0.28rem"
              v-if="scope.row.fin_table && scope.row.fin_table.end_time"
            >
              {{ scope.row.fin_table.end_time }}
            </div>
            <div v-else>未知</div>
          </template>
        </el-table-column>
        <el-table-column prop="normal" label="正常反馈" width="110">
          <template slot-scope="scope">
            <ul v-for="(item, index) in [scope.row.normal]" :key="index">
              <li v-for="(i, key) in item" :key="i.id">
                <span style="font-size: 0.28rem">
                  <i>{{ key + ":" }}</i>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="点击查看"
                    placement="top"
                  >
                    <i
                      style="margin-left: 0.2rem; cursor: pointer; color: #409eff"
                      @click="openNormal(scope.row.id, key)"
                      >{{ i.length }}</i
                    >
                  </el-tooltip>
                </span>
              </li>
            </ul>
          </template>
        </el-table-column>
        <el-table-column prop="other" label="存在问题" width="130">
          <template slot-scope="scope">
            <ul>
              <li v-for="(i, key, index) in scope.row.other" :key="index">
                <span style="font-size: 0.28rem">
                  <i>{{ key + ":" }}</i>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="点击查看"
                    placement="top"
                  >
                    <i
                      style="margin-left: 0.2rem; cursor: pointer; color: #409eff"
                      v-if="i.handle"
                      @click="openNotNormal(scope.row.id, key)"
                      >{{ "【" + i.handle.length + "/" + i.problem.length + "】" }}</i
                    >
                    <i
                      style="margin-left: 0.2rem; cursor: pointer; color: #409eff"
                      v-else
                      @click="openNotNormal(scope.row.id, key)"
                      >{{ "【" + "0" + "/" + i.problem.length + "】" }}</i
                    >
                  </el-tooltip>
                </span>
              </li>
            </ul>
          </template>
        </el-table-column>
        <el-table-column prop="business" label="业务员" width="140">
          <template slot-scope="scope">
            <ul v-for="(item, index) in [scope.row.business]" :key="index">
              <li v-for="(i, key) in item" :key="i.id">
                <span style="font-size: 0.28rem">
                  <i>{{ key + ":" }}</i>
                  <i style="margin-left: 0.2rem">{{ i.length }}</i>
                </span>
              </li>
            </ul>
          </template>
        </el-table-column>
        <el-table-column prop="kefu" label="客服会计" width="140">
          <template slot-scope="scope">
            <ul v-for="(item, index) in [scope.row.kefu]" :key="index">
              <li v-for="(i, key) in item" :key="i.id">
                <span style="font-size: 0.28rem">
                  <i>{{ key + ":" }}</i>
                  <i style="margin-left: 0.2rem">{{ i.length }}</i>
                </span>
              </li>
            </ul>
          </template>
        </el-table-column>
        <el-table-column prop="jizhang" label="理票会计" width="140">
          <template slot-scope="scope">
            <ul v-for="(item, index) in [scope.row.jizhang]" :key="index">
              <li v-for="(i, key) in item" :key="i.id">
                <span style="font-size: 0.28rem">
                  <i>{{ key + ":" }}</i>
                  <i style="margin-left: 0.2rem">{{ i.length }}</i>
                </span>
              </li>
            </ul>
          </template>
        </el-table-column>
        <el-table-column prop="tax" label="记账报税会计" width="140">
          <template slot-scope="scope">
            <ul v-for="(item, index) in [scope.row.tax]" :key="index">
              <li v-for="(i, key) in item" :key="i.id">
                <span style="font-size: 0.28rem">
                  <i>{{ key + ":" }}</i>
                  <i style="margin-left: 0.2rem">{{ i.length }}</i>
                </span>
              </li>
            </ul>
          </template>
        </el-table-column>
        <el-table-column prop="kaipiao" label="开票会计" width="140">
          <template slot-scope="scope">
            <ul v-for="(item, index) in [scope.row.kaipiao]" :key="index">
              <li v-for="(i, key) in item" :key="i.id">
                <span style="font-size: 0.28rem">
                  <i>{{ key + ":" }}</i>
                  <i style="margin-left: 0.2rem">{{ i.length }}</i>
                </span>
              </li>
            </ul>
          </template>
        </el-table-column>
        <el-table-column prop="zuzhang" label="财税负责人" width="140">
          <template slot-scope="scope">
            <ul v-for="(item, index) in [scope.row.zuzhang]" :key="index">
              <li v-for="(i, key) in item" :key="i.id">
                <span style="font-size: 0.28rem">
                  <i>{{ key + ":" }}</i>
                  <i style="margin-left: 0.2rem">{{ i.length }}</i>
                </span>
              </li>
            </ul>
          </template>
        </el-table-column>
        <el-table-column prop="otherUser" label="公司其他人员" width="140">
          <template slot-scope="scope">
            <ul v-for="(item, index) in [scope.row.otherUser]" :key="index">
              <li v-for="(i, key) in item" :key="i.id">
                <span style="font-size: 0.28rem">
                  <i>{{ key + ":" }}</i>
                  <i style="margin-left: 0.2rem">{{ i.length }}</i>
                </span>
              </li>
            </ul>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" fixed="right" width="190">
          <!-- <el-table-column label="编辑" align="center" > -->
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" content="添加续费建议" placement="top">
              <el-button
                @click.native.prevent="categoryIn(scope.row.id, scope.row.company_name)"
                type="primary"
                size="mini"
                icon="el-icon-document-add"
                circle
              >
              </el-button>
            </el-tooltip>
            <!-- :disabled="scope.row.wx_work_chat_com ? false : true" -->
            <el-tooltip
              class="item"
              effect="dark"
              content="企业微信群聊天记录"
              placement="top"
            >
              <el-button
                type="warning"
                @click="
                  handleWxChatOpen(scope.row.wx_work_chat_com, scope.row.company_name)
                "
                size="mini"
                icon="el-icon-s-comment"
                circle
                :disabled="scope.row.wx_work_chat_com ? false : true"
              ></el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="聊天记录" placement="top">
              <el-button
                type="primary"
                :disabled="scope.row.chat_com ? false : true"
                @click="handleChatOpen(scope.row.chat_com, scope.row.company_name)"
                size="mini"
                icon="el-icon-s-comment"
                circle
              ></el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="电话联系记录" placement="top">
              <el-button
                type="primary"
                size="mini"
                icon="el-icon-phone-outline"
                circle
                @click="handCallLogsOpen(scope.row)"
              ></el-button>
            </el-tooltip>
            <!-- <el-tooltip
              class="item"
              effect="dark"
              content="修改"
              placement="top"
            >
              <el-button
                @click.native.prevent="editRow(scope.$index, categoryData)"
                type="primary"
                size="mini"
                icon="el-icon-edit"
                circle
              >
              </el-button>
            </el-tooltip> -->
            <!-- categoryIn -->
            <!-- <el-tooltip
              class="item"
              effect="dark"
              content="删除"
              placement="top"
            >
              <el-button
                @click.native.prevent="deleteRow(scope.$index, categoryData)"
                type="danger"
                size="mini"
                icon="el-icon-delete"
                circle
              >
              </el-button>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              content="阅读记录"
              placement="top"
            >
              <el-button
                @click.native.prevent="readRow(scope.$index, categoryData)"
                type="success"
                size="mini"
                icon="el-icon-notebook-2"
                circle
              >
              </el-button>
            </el-tooltip> -->
          </template>
          <!-- </el-table-column> -->
          <!-- <el-table-column label="设为案例" align="center" fixed="right">
          <template slot-scope="scope">
            <el-radio-group
              v-model="ifuse[scope.$index]"
              size="mini"
              @change="setRow($event, scope.row)"
            >
              <el-radio-button :label="1">是</el-radio-button>
              <el-radio-button :label="'0'">否</el-radio-button>
            </el-radio-group>
          </template>
        </el-table-column> -->
        </el-table-column>
      </el-table>
    </div>

    <div class="page-footer">
      <el-pagination
        class="pagination-style"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        layout="sizes, total, prev, pager, next, jumper"
        :total="total"
        :page-sizes="[10, 20, 30, 50, 100, 500]"
        :page-size="categoryPerPage"
        background
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import Chat from "common/Chat";
import CompanyInfo from "common/CompanyInfo";
import WxWorkChat from "common/WxWorkChat";
import CallLogs from "common/CallLogs";
import { filterKeywordOptions } from '../../lib/cascaderUtils.js';

export default {
  name: "QualityInspection",
  components: { CompanyInfo, WxWorkChat, CallLogs, Chat },
  data() {
    var categoryId = (rule, value, callback) => {
      if (value.length === 0) {
        return callback(new Error("请选择问题类型！"));
      }
      callback();
    };
    var checkIncharge = (rule, value, callback) => {
      if (value.length === 0) {
        return callback(new Error("请选择责任人！"));
      }
      callback();
    };
    var checkDoneat = (rule, value, callback) => {
      if (value.length === 0) {
        return callback(new Error("请选择ETA处理时间！"));
      }
      callback();
    };
    var checkrec = (rule, value, callback) => {
      if (value.length === 0) {
        return callback(new Error("请输入处理结果！"));
      }
      callback();
    };
    var checkdesc = (rule, value, callback) => {
      if (value.length > 500) {
        return callback(new Error("输入过长！"));
      }
      if (value.length === 0) {
        return callback(new Error("请输入描述内容！"));
      }
      callback();
    };
    var checkcase = (rule, value, callback) => {
      if (value.length > 500) {
        return callback(new Error("输入过长！"));
      }
      if (value.length === 0) {
        return callback(new Error("请输入处理方案！"));
      }
      callback();
    };
    var checkCompany = (rule, value, callback) => {
      if (value.length === 0) {
        return callback(new Error("请选择公司！"));
      }
      callback();
    };
    var checkproblem = (rule, value, callback) => {
      if (value.length === 0) {
        return callback(new Error("请选择是否有问题！"));
      }
      callback();
    };
    return {
      visible: false,
      activeNames: [],
      searchArr: {
        title: "",
      },
      searchForm: {
        categoryId: "",
        advice_name: "",
        advice_cate: "",
        is_problem: "",
        other: [],
        month: "",
        companyId: "",
        feedback_at: "",
        is_use: "",
        business: "",
        kefu: "",
        jizhang: "",
        tax: "",
        kaipiao: "",
        leader: "",
        qita: "",
        businessC: "",
        kefuC: "",
        jizhangC: "",
        taxC: "",
        kaipiaoC: "",
        leaderC: "",
        cancelOrLost: "",
        ifNormal: "",
        incharge: "",
        done_at: [],
        serviceOvered: "",
      },
      chatId: null,
      chatCompany: null,
      overMonth: "",
      month: "",
      monthAl: "",
      month1: "",
      month1Al: "",
      month2: "",
      month2Al: "",
      month3: "",
      month3Al: "",
      month4: "",
      month4Al: "",
      monthsub1: "",
      monthsub1Al: "",
      nowMonthAl: "",
      nowMonthAlPro: "",
      nowMonthAlNor: "",
      lsyj: "",
      bdzx: "",
      qrls: "",
      nowMonthAlProAl: "",
      nowMonthAlProIng: "",
      nowMonthAlProPause: "",
      quains_company_name: null,
      screenDialog: false,
      reSizeDialog: false,
      chatDrawer: false,
      wxWorkChatId: null,
      wxWorkchatCompany: null,
      wxChatDrawer: false,
      screenDialogData: [],
      reSizeUrl: "",
      problemScreenDialog: false,
      problemScreenDialogData: [],
      needUrl: [],
      needUrlPro: [],
      editNeedUrl: [],
      npage: 1,
      categoryPerPage: 30,
      total: null,
      categoryData: [],
      searchTitles: [],
      searchBodies: [],
      searchEditBodies: [],
      roleOptions: [],
      cateOptions: [],
      cateEditOptions: [],
      roleEditOptions: [],
      dateCountData: [],
      agreeData: [],
      wonderfulData: [],
      fileReadRecOptions: [],
      searcher: null,
      categoryEditDrawer: false,
      categoryReadDrawer: false,
      searchLoading: false,
      laterCid: null,
      laterMonth: null,
      searchCompanies: [],
      searchCompaniesx: [],
      searchCategories: [],
      categoryIndrawer: false,
      countSuccess: 0,
      businessOptions: [],
      kefuOptions: [],
      jizhangOptions: [],
      taxOptions: [],
      kaipiaoOptions: [],
      leaderOptions: [],
      qitaOptions: [],
      businessOptionsC: [],
      kefuOptionsC: [],
      jizhangOptionsC: [],
      taxOptionsC: [],
      kaipiaoOptionsC: [],
      leaderOptionsC: [],
      searchInchargeOptions: [],
      editIfDisplay: false,
      direction: "rtl",
      category: "",
      ideCateId: null,
      ifdisplay: false,
      companyInfoDrawer: false,
      companyComId: null,
      cities: [],
      countAdvice: "",
      countRead: "",
      countAgree: "",
      countNotAgree: "",
      change: false,
      api: "api/quains/upscr",
      header: {
        Authorization: localStorage.getItem("token"),
      },
      limit: 10,
      formData: {},
      fileList: [],
      fileListPro: [],
      editFileList: [],
      dialogImageUrl: "",
      dialogImageUrlPro: "",
      dialogImageUrlE: "",
      dialogVisible: false,
      dialogVisiblePro: false,
      dialogVisibleE: false,
      normalDrawer: false,
      notNormalDrawer: false,
      notNormalDrawerHandle: false,
      handleProblemDrawer: false,
      callLogsDrawer: false,
      handlProblemId: null,
      company: null,
      callPhone: [],
      callPhone1: [],
      callPhone2: [],
      callPhone3: [],
      normalData: [],
      notNormalData: [],
      notNormalDataHandle: [],
      adviceNameOptions: [],
      adviceCateOptions: [],
      problemOptions: [],
      searchProblemOptions: [],
      inchargeOptions: [],
      ifuse: [],
      rangePickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      donePickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 3600 * 1000 * 24;
        },
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      searchRangePickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      categoryForm: {
        categoryId: [],
        problem: "",
        describe: "",
        companyId: "",
        incharge: "",
        done_at: [],
        cancelOrLost: "",
        ifNormal: "",
      },
      problemForm: {
        id: "",
        case: "",
        resulat: "",
      },
      other: {
        company_name: "",
        month: "",
      },
      categoryEditForm: {
        categoryId: "",
        body: "",
        companyId: "",
      },
      editCategoryForm: {
        categoryId: "",
        category_name: "",
      },
      rules: {
        categoryId: [
          {
            validator: categoryId,
            trigger: "blur",
          },
        ],
        incharge: [
          {
            validator: checkIncharge,
            trigger: "blur",
          },
        ],
        done_at: [
          {
            validator: checkDoneat,
            trigger: "blur",
          },
        ],
        describe: [
          {
            validator: checkdesc,
            trigger: "blur",
          },
        ],
        problem: [
          {
            validator: checkproblem,
            trigger: "blur",
          },
        ],
        companyId: [
          {
            validator: checkCompany,
            trigger: "blur",
          },
        ],
      },
      rulesPro: {
        case: [
          {
            validator: checkcase,
            trigger: "blur",
          },
        ],
        resulat: [
          {
            validator: checkrec,
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {
    this.loadTable();
    this.loadCategory();
    this.loadAdvice();
    this.loadAdviceCate();
  },
  // watch: {
  //   searcher: function (n, o) {
  //     this.loadTable(n)
  //   }
  // },
  computed: {
    collapse() {
      return this.$store.state.collapse;
    },
  },
  methods: {
    // 复制功能
    copy(data) {
      // 存储传递过来的数据
      let OrderNumber = data;
      // 创建一个input 元素
      // createElement() 方法通过指定名称创建一个元素
      let newInput = document.createElement("input");
      // 讲存储的数据赋值给input的value值
      newInput.value = OrderNumber;
      // appendChild() 方法向节点添加最后一个子节点。
      document.body.appendChild(newInput);
      // 选中input元素中的文本
      // select() 方法用于选择该元素中的文本。
      newInput.select();
      // 执行浏览器复制命令
      //  execCommand方法是执行一个对当前文档，当前选择或者给出范围的命令
      document.execCommand("Copy");
      // 清空输入框
      newInput.remove();
      // 下面是element的弹窗 不需要的自行删除就好
      this.$message({
        message: "复制成功",
        type: "success",
      });
    },
    copySome(data) {
      this.copy(data);
    },
    filterOptions(node, keyword) {
  return filterKeywordOptions(node, keyword);
},
    loadAdviceCate() {
      this.$axios
        .get("api/quains/getcate")
        .then((res) => {
          const { data } = res;
          if (data.code === 1) {
            this.adviceCateOptions = data.data;
          } else {
            this.$message.error(data.msg);
          }
        })
        .catch();
    },
    loadAdvice() {
      this.$axios
        .get("api/expmanage/getreceiver")
        .then((res) => {
          const { data } = res;
          if (data.code === 1) {
            this.adviceNameOptions = data.data;
          } else {
            this.$message.error(data.msg);
          }
        })
        .catch();
    },
    loadIncharge() {
      this.$axios
        .get("api/quains/incharge?company_id=" + this.categoryForm.companyId)
        .then((res) => {
          const { data } = res;
          if (data.code === 1) {
            this.inchargeOptions = data.data;
          } else {
            this.$message.error(data.msg);
          }
        })
        .catch();
    },
    loadCategory() {
      this.$axios
        .get("api/quains/getcate")
        .then(({ data }) => {
          if (data.code === 1) {
            this.problemOptions = data.data;
          }
        })
        .catch();
    },
    getSearchProblemOptions() {
      this.$axios
        .get("api/quains/getcate")
        .then(({ data }) => {
          if (data.code === 1) {
            this.searchProblemOptions = data.data;
          }
        })
        .catch();
    },
    loadTable() {
      // console.log(this.searchForm);return;
      this.$axios
        .get("api/quains/index", {
          params: {
            page: this.npage,
            perpage: this.categoryPerPage,
            searchItem: this.searchForm,
          },
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.categoryData = data.data.data;
            this.total = data.data.total;
            this.overMonth = data.count.overMonth;
            this.month = data.count.month[1];
            this.monthAl = data.count.month[0];
            this.month1 = data.count.month1[1];
            this.month1Al = data.count.month1[0];
            this.month2 = data.count.month2[1];
            this.month2Al = data.count.month2[0];
            this.month3 = data.count.month3[1];
            this.month3Al = data.count.month3[0];
            this.month4 = data.count.month4[1];
            this.month4Al = data.count.month4[0];
            this.monthsub1 = data.count.monthsub1[1];
            this.monthsub1Al = data.count.monthsub1[0];
            // this.nowMonth = data.count.nowMonth
            this.nowMonthAl = data.count.nowMonthAl;
            this.nowMonthAlPro = data.count.nowMonthAlPro;
            this.nowMonthAlNor = data.count.nowMonthAlNor;
            this.lsyj = data.count.lsyj;
            this.bdzx = data.count.bdzx;
            this.qrls = data.count.qrls;
            this.nowMonthAlProAl = data.count.nowMonthAlProAl;
            this.nowMonthAlProIng = data.count.nowMonthAlProIng;
            this.nowMonthAlProPause = data.count.nowMonthAlProPause;
            var myEvent = new Event("click");
            document.dispatchEvent(myEvent);
          }
        })
        .catch();
    },
    setExa() {
      this.categoryData.map((item, index) => {
        if (item.is_use === 1) {
          this.ifuse[index] = 1;
        } else {
          this.ifuse[index] = 0;
        }
      });
    },
    handleCurrentChange(val) {
      this.npage = val;
      this.loadTable();
    },
    handleSizeChange(val) {
      this.categoryPerPage = val;
      this.loadTable();
    },
    editRow(index, data) {
      this.editFileList = [];
      this.$axios
        .get("api/quains/show", {
          params: {
            id: data[index].id,
          },
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.other.company_name = data.data.company_name;
            this.other.month = data.data.month;
            this.categoryEditForm.categoryId = data.data.cate.cate_id;
            this.ideCateId = data.data.cate.cate_id;
            this.categoryEditForm.body = data.data.body;
            this.category = data.data.id;
            var fileUrl = data.data.file.map((item) => {
              return item;
            });
            this.editFileList = fileUrl;
          }
        })
        .catch();
      this.categoryEditDrawer = true;
    },
    readRow(index, data) {
      this.$axios
        .get("api/quains/getrecord", {
          params: {
            id: data[index].id,
          },
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.fileReadRecOptions = data.data;
          }
        })
        .catch();
      this.categoryReadDrawer = true;
    },
    deleteRow(index, data) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .delete("api/quains/del", {
              params: {
                id: data[index].id,
              },
            })
            .then(({ data }) => {
              if (data.code === 1) {
                this.loadTable();
                this.$message.success(data.msg);
              } else {
                this.$message.error(data.msg);
              }
            })
            .catch();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    searchRemoteCfcategory(query) {
      if (query !== "") {
        this.searchLoading = true;
        setTimeout(() => {
          this.searchLoading = false;
          this.searchItem(query);
        }, 200);
      } else {
        this.searchCategories = [];
      }
    },
    searchItem(query) {
      this.$axios
        .get("api/quains/getitem", {
          params: {
            search: query,
          },
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.searchCategories = data.data;
          }
        })
        .catch();
    },
    searchRemoteCfTitle(query) {
      if (query !== "") {
        this.searchLoading = true;
        setTimeout(() => {
          this.searchLoading = false;
          this.searchItemTitle(query);
        }, 200);
      } else {
        this.searchtitles = [];
      }
    },
    searchItemTitle(query) {
      this.$axios
        .get("api/quains/getitem", {
          params: {
            search: query,
          },
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.searchTitles = data.data;
          }
        })
        .catch();
    },
    searchRemoteCfbody(query) {
      if (query !== "") {
        this.searchLoading = true;
        setTimeout(() => {
          this.searchLoading = false;
          this.searchItemBody(query);
        }, 200);
      } else {
        this.searchBodies = [];
      }
    },
    searchItemBody(query) {
      this.$axios
        .get("api/cloudfile/getitem", {
          params: {
            search: query,
          },
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.searchBodies = data.data;
          }
        })
        .catch();
    },
    searchRemoteCfbodyEdit(query) {
      if (query !== "") {
        this.ideCateId = null;
        this.searchLoading = true;
        setTimeout(() => {
          this.searchLoading = false;
          this.searchItemBodyEdit(query);
        }, 200);
      } else {
        this.searchEditBodies = [];
      }
    },
    searchItemBodyEdit(query) {
      this.$axios
        .get("api/cloudfile/getitem", {
          params: {
            search: query,
          },
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.searchEditBodies = data.data;
          }
        })
        .catch();
    },
    handleSearchCfcategory(query) {
      this.searcher = query;
      setTimeout(() => {
        this.loadTable();
      });
    },
    handleSearchCfTitle(query) {
      this.searcher = query;
      setTimeout(() => {
        this.loadTable();
      });
    },
    handleSearchCfBody(query) {
      this.searcher = query;
      setTimeout(() => {
        this.loadTable();
      });
    },
    categoryIn(id, cname) {
      this.quains_company_name = cname;
      this.categoryForm.companyId = id;
      this.categoryIndrawer = true;
    },
    handleCloseIn(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          this.$refs.categoryForm.resetFields();
          this.$refs.uploadMutiple.clearFiles();
          this.needUrl = [];
          done();
        })
        .catch((_) => {});
    },
    handleCloseProblem(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          this.$refs.problemForm.resetFields();
          this.$refs.uploadMutiplePro.clearFiles();
          this.needUrlPro = [];
          done();
        })
        .catch((_) => {});
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          this.editFileList = [];
          done();
        })
        .catch((_) => {});
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.categoryForm.file = this.needUrl;
          this.$axios
            .post("api/quains/store", this.categoryForm)
            .then((res) => {
              const { data } = res;
              if (data.code === 1) {
                this.$refs.categoryForm.resetFields();
                this.$refs.uploadMutiple.clearFiles();
                this.needUrl = [];
                this.$message.success(data.msg);
                this.categoryIndrawer = false;
                this.loadTable();
              } else {
                this.$message.error(data.msg);
              }
            })
            .catch();
        } else {
          return false;
        }
      });
    },
    submitFormPro(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.problemForm.file = this.needUrlPro;
          this.$axios
            .post("api/quains/prostore", this.problemForm)
            .then((res) => {
              const { data } = res;
              if (data.code === 1) {
                this.$refs.problemForm.resetFields();
                this.$refs.uploadMutiplePro.clearFiles();
                this.needUrlPro = [];
                this.$message.success(data.msg);
                this.openNotNormal(this.laterCid, this.laterMonth);
                this.loadTable();
                this.handleProblemDrawer = false;
              } else {
                this.$message.error(data.msg);
              }
            })
            .catch();
        } else {
          return false;
        }
      });
    },
    editSubmitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var oldId = this.editFileList.map((item) => {
            return item.id;
          });
          this.$axios
            .put("api/quains/edit", {
              id: this.category,
              ideCateId: this.ideCateId,
              cateId: this.categoryEditForm.categoryId,
              body: this.categoryEditForm.body,
              oldId: oldId,
              change: this.change,
              newFile: this.editNeedUrl,
            })
            .then((res) => {
              const { data } = res;
              if (data.code === 1) {
                this.editNeedUrl = [];
                this.editFileList = [];
                this.change = false;
                this.$message.success(data.msg);
                this.categoryEditDrawer = false;
                this.loadTable();
              } else {
                this.$message.error(data.msg);
              }
            })
            .catch();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    getRole() {
      this.$axios
        .get("api/quains/role")
        .then((res) => {
          const { data } = res;
          if (data.code === 1) {
            this.roleOptions = data.data;
          } else {
            this.$message.error(data.msg);
          }
        })
        .catch();
    },
    getCate() {
      this.$axios
        .get("api/quains/cate")
        .then((res) => {
          const { data } = res;
          if (data.code === 1) {
            this.cateOptions = data.data;
          } else {
            this.$message.error(data.msg);
          }
        })
        .catch();
    },
    getCateEdit() {
      this.$axios
        .get("api/quains/cate")
        .then((res) => {
          const { data } = res;
          if (data.code === 1) {
            this.cateEditOptions = data.data;
          } else {
            this.$message.error(data.msg);
          }
        })
        .catch();
    },
    readRecord(row) {
      let newPage = this.$router.resolve({
        path: "/documentation",
        query: { url: row.body },
      });
      window.open(newPage.href, "_blank");

      this.$axios
        .post("api/quains/readrecord", {
          id: row.id,
          title: row.title,
        })
        .then(({ data }) => {
          if (data.code === 1) {
            // this.comNoticeData = data.data.data
            // this.total = data.data.total
          }
        })
        .catch();
    },
    searchRemoteCompanyMethod(query) {
      if (query !== "") {
        this.searchLoading = true;
        this.searchArrItemCompanys(query);
        setTimeout(() => {
          this.searchLoading = false;
        }, 200);
      } else {
        this.searchCompanies = [];
      }
    },
    searchArrItemCompanys(query) {
      this.$axios.get("/api/admin/searchCompany?name=" + query).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.searchCompanies = data.data.companies;
        }
      });
    },
    searchRemoteCompanyMethodS(query) {
      if (query !== "") {
        this.searchLoading = true;
        this.searchArrItemCompanysx(query);
        setTimeout(() => {
          this.searchLoading = false;
        }, 200);
      } else {
        this.searchCompaniesx = [];
      }
    },
    searchArrItemCompanysx(query) {
      this.$axios.get("/api/admin/searchCompany?name=" + query).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.searchCompaniesx = data.data.companies;
        }
      });
    },
    // 监听粘贴操作
    handlePaste(event) {
      const items = (event.clipboardData || window.clipboardData).items;
      let file = null;
      if (!items || items.length === 0) {
        this.$message.error("当前浏览器不支持本地");
        return;
      }
      // 搜索剪切板items
      for (let i = 0; i < items.length; i++) {
        if (items[i].type.indexOf("image") !== -1) {
          file = items[i].getAsFile();
          break;
        }
      }
      if (!file) {
        this.$message.error("粘贴内容非图片");
        return;
      }
      if (this.fileList.length >= this.limit) {
        this.$message.error(`上传文件数量不能超过 ${this.limit} 个!`); // 图片数量超出
        return;
      }
      this.$refs.uploadMutiple.handleStart(file); // 将粘贴过来的图片加入预上传队列
      this.$refs.uploadMutiple.submit(); // 提交图片上传队列
    },

    handlePastePro(event) {
      const items = (event.clipboardData || window.clipboardData).items;
      let file = null;
      if (!items || items.length === 0) {
        this.$message.error("当前浏览器不支持本地");
        return;
      }
      // 搜索剪切板items
      for (let i = 0; i < items.length; i++) {
        if (items[i].type.indexOf("image") !== -1) {
          file = items[i].getAsFile();
          break;
        }
      }
      if (!file) {
        this.$message.error("粘贴内容非图片");
        return;
      }
      if (this.fileListPro.length >= this.limit) {
        this.$message.error(`上传文件数量不能超过 ${this.limit} 个!`); // 图片数量超出
        return;
      }
      this.$refs.uploadMutiplePro.handleStart(file); // 将粘贴过来的图片加入预上传队列
      this.$refs.uploadMutiplePro.submit(); // 提交图片上传队列
    },

    handleRemove(file, fileList) {
      this.needUrl.map((item, index) => {
        if (item.uid === file.uid) {
          this.needUrl.splice(index, 1);
        }
      });
      this.fileList = fileList;
    },
    handleRemovePro(file, fileList) {
      this.needUrlPro.map((item, index) => {
        if (item.uid === file.uid) {
          this.needUrlPro.splice(index, 1);
        }
      });
      this.fileListPro = fileList;
    },

    handlePictureCardPreview(file) {
      this.dialogVisible = true;
      this.dialogImageUrl = file.url;
    },
    handlePictureCardPreviewPro(file) {
      this.dialogVisiblePro = true;
      this.dialogImageUrlPro = file.url;
    },
    handleAvatarSuccess(res, file) {
      if (res.code === 1) {
        this.needUrl.push({ url: res.url, name: file.name, uid: file.uid });
      }
      // this.imageUrl = URL.createObjectURL(file.raw)
    },
    handleAvatarSuccessPro(res, file) {
      if (res.code === 1) {
        this.needUrlPro.push({ url: res.url, name: file.name, uid: file.uid });
      }
      // this.imageUrl = URL.createObjectURL(file.raw)
    },
    handleAvatarChange(res, file) {
      this.fileList = file;
    },
    handleAvatarChangePro(res, file) {
      this.fileListPro = file;
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传图片格式为JPG或PNG!");
        return;
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
        return false;
      }
      // return isJPG && isLt2M
    },
    editHandlePaste(event) {
      const items = (event.clipboardData || window.clipboardData).items;
      let file = null;
      if (!items || items.length === 0) {
        this.$message.error("当前浏览器不支持本地");
        return;
      }
      // 搜索剪切板items
      for (let i = 0; i < items.length; i++) {
        if (items[i].type.indexOf("image") !== -1) {
          file = items[i].getAsFile();
          break;
        }
      }
      if (!file) {
        this.$message.error("粘贴内容非图片");
        return;
      }
      if (this.editFileList.length >= this.limit) {
        this.$message.error(`上传文件数量不能超过 ${this.limit} 个!`); // 图片数量超出
        return;
      }
      this.$refs.editUploadMutiple.handleStart(file); // 将粘贴过来的图片加入预上传队列
      this.$refs.editUploadMutiple.submit(); // 提交图片上传队列
    },

    editHandleRemove(file, fileList) {
      // this.editFileList.map((item, index) => {
      //   if (item.uid === file.uid) {
      //     this.editFileList.splice(index, 1)
      //   }
      // })
      this.editFileList = fileList;
      this.change = true;
    },

    editHandlePictureCardPreview(file) {
      this.dialogVisibleE = true;
      this.dialogImageUrlE = file.url;
    },
    editHandleAvatarSuccess(res, file) {
      if (res.code === 1) {
        this.editNeedUrl.push({ url: res.url, name: file.name });
      }
      // this.imageUrl = URL.createObjectURL(file.raw)
    },
    editHandleAvatarChange(res, file) {
      this.editFileList = file;
      this.change = true;
    },
    editBeforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传图片格式为JPG或PNG!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    openCompanyCom(row) {
      this.companyInfoDrawer = true;
      setTimeout(() => {
        this.companyComId = row.id;
      });
    },
    resetForm(formName) {
      this.visible = false;
      this.$refs[formName].resetFields();
    },
    doSearch() {
      this.visible = false;
      this.npage = 1;
      this.loadTable();
    },
    toSearch(val) {
      this.npage = 1;
      this.loadTable();
    },
    setRow(evt, row) {
      this.$axios
        .put("api/quains/setas", {
          id: row.id,
          is_use: evt,
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.loadTable();
            this.$message.success(data.msg);
          } else {
            this.$message.error(data.msg);
          }
        })
        .catch();
    },
    cancelSetRow(row) {
      //
    },
    getWonderful() {
      this.$axios
        .get("api/quains/wonderfullist")
        .then(({ data }) => {
          if (data.code === 1) {
            this.wonderfulData = data.data;
          } else {
            this.$message.error(data.msg);
          }
        })
        .catch();
    },
    getAgree() {
      this.$axios
        .get("api/quains/agreelist")
        .then(({ data }) => {
          if (data.code === 1) {
            this.agreeData = data.data;
          } else {
            this.$message.error(data.msg);
          }
        })
        .catch();
    },
    ifProblem(val) {
      if (val === 1) {
        this.loadCategory();
        this.loadIncharge();
        this.categoryForm.ifNormal = false;
      }
      if (val === "0") {
        this.categoryForm.cancelOrLost = "";
        this.categoryForm.incharge = null;
        this.categoryForm.done_at = null;
        this.categoryForm.categoryId = null;
      }
    },
    searchIfNoraml(val) {
      if (val === 1) {
        this.searchForm.ifNormal = false;
      }
      if (val === "0") {
        this.searchForm.cancelOrLost = "";
        this.searchForm.incharge = null;
        this.searchForm.done_at = null;
        this.searchForm.categoryId = null;
      }
    },
    openNormal(cid, month) {
      this.normalData = [];
      this.$axios
        .get("api/quains/normal?companyId=" + cid + "&month=" + month)
        .then(({ data }) => {
          if (data.code === 1) {
            this.normalData = data.data;
          } else {
            this.$message.error(data.msg);
          }
        })
        .catch();
      this.normalDrawer = true;
    },
    openNotNormal(cid, month) {
      this.laterCid = cid;
      this.laterMonth = month;
      this.$axios
        .get("api/quains/notnormal?companyId=" + cid + "&month=" + month)
        .then(({ data }) => {
          if (data.code === 1) {
            this.notNormalData = data.data;
          } else {
            this.$message.error(data.msg);
          }
        })
        .catch();
      this.notNormalDrawer = true;
    },
    openHandleDetail(id) {
      this.$axios
        .get("api/quains/handledetail?id=" + id)
        .then(({ data }) => {
          if (data.code === 1) {
            this.notNormalDataHandle = data.data;
          } else {
            this.$message.error(data.msg);
          }
        })
        .catch();
      this.notNormalDrawerHandle = true;
    },
    handleProblem(id) {
      this.problemForm.id = id;
      this.handleProblemDrawer = true;
    },

    loadAdminUser() {
      return this.$axios.get("api/admin/user/branch");
    },
    loadAdminBus() {
      this.loadAdminUser().then(({ data }) => {
        if (data.code === 1) {
          this.businessOptions = data.data;
        }
      });
    },
    loadAdminKefu() {
      this.loadAdminUser().then(({ data }) => {
        if (data.code === 1) {
          this.kefuOptions = data.data;
        }
      });
    },
    loadAdminJizhang() {
      this.loadAdminUser().then(({ data }) => {
        if (data.code === 1) {
          this.jizhangOptions = data.data;
        }
      });
    },
    loadAdminTax() {
      this.loadAdminUser().then(({ data }) => {
        if (data.code === 1) {
          this.taxOptions = data.data;
        }
      });
    },
    loadAdminKaipiao() {
      this.loadAdminUser().then(({ data }) => {
        if (data.code === 1) {
          this.kaipiaoOptions = data.data;
        }
      });
    },
    loadAdminLeader() {
      this.loadAdminUser().then(({ data }) => {
        if (data.code === 1) {
          this.leaderOptions = data.data;
        }
      });
    },
    loadAdminQita() {
      this.loadAdminUser().then(({ data }) => {
        if (data.code === 1) {
          this.qitaOptions = data.data;
        }
      });
    },
    loadAdminBusC() {
      this.loadAdminUser().then(({ data }) => {
        if (data.code === 1) {
          this.businessOptionsC = data.data;
        }
      });
    },
    loadAdminKefuC() {
      this.loadAdminUser().then(({ data }) => {
        if (data.code === 1) {
          this.kefuOptionsC = data.data;
        }
      });
    },
    loadAdminJizhangC() {
      this.loadAdminUser().then(({ data }) => {
        if (data.code === 1) {
          this.jizhangOptionsC = data.data;
        }
      });
    },
    loadAdminTaxC() {
      this.loadAdminUser().then(({ data }) => {
        if (data.code === 1) {
          this.taxOptionsC = data.data;
        }
      });
    },
    loadAdminKaipiaoC() {
      this.loadAdminUser().then(({ data }) => {
        if (data.code === 1) {
          this.kaipiaoOptionsC = data.data;
        }
      });
    },
    loadAdminLeaderC() {
      this.loadAdminUser().then(({ data }) => {
        if (data.code === 1) {
          this.leaderOptionsC = data.data;
        }
      });
    },
    getSearchInchargeOptions() {
      this.loadAdminUser().then(({ data }) => {
        if (data.code === 1) {
          this.searchInchargeOptions = data.data;
        }
      });
    },
    openScreen(data) {
      this.screenDialogData = data;
      this.screenDialog = true;
    },
    reSizePic(url) {
      this.reSizeUrl = url;
      this.reSizeDialog = true;
    },
    handleWxChatOpen(chat, companyName) {
      console.log(chat, companyName);
      if (chat) {
        this.wxChatDrawer = true;
        setTimeout(() => {
          this.wxWorkChatId = chat.chat_id;
          this.wxWorkchatCompany = companyName;
        });
      }
    },
    handleWxChatBeforeClose(done) {
      this.wxWorkChatId = "";
      this.wxWorkchatCompany = "";
      done();
    },
    handCallLogsOpen(row) {
      this.callLogsDrawer = true;
      setTimeout(() => {
        this.company = row.company_name;
        if (row.user) this.callPhone.push(row.user.phone);
        if (row.docking_phone) this.callPhone3.push(row.docking_phone);
        if (row.tyc_orders.length > 0) {
          for (var i = 0; i < row.tyc_orders.length; i++) {
            if (
              row.tyc_orders[i].customer_phone &&
              this.callPhone1.indexOf(row.tyc_orders[i].customer_phone) === -1
            ) {
              this.callPhone1.push(row.tyc_orders[i].customer_phone);
            }
            if (
              row.tyc_orders[i].corporate_phone &&
              this.callPhone2.indexOf(row.tyc_orders[i].corporate_phone) === -1
            ) {
              this.callPhone2.push(row.tyc_orders[i].corporate_phone);
            }
          }
        }
      });
    },
    handleCallLogsBeforeClose(done) {
      this.company = "";
      this.callPhone = [];
      this.callPhone1 = [];
      this.callPhone2 = [];
      this.callPhone3 = [];
      done();
    },
    handleChatOpen(chat, companyName) {
      if (chat) {
        this.chatDrawer = true;
        setTimeout(() => {
          this.chatId = chat.chat_id;
          this.chatCompany = companyName;
        });
      }
    },
    handleChatBeforeClose(done) {
      this.clearChatsData();
      done();
    },
    clearChatsData() {
      this.chatId = "";
      this.chatName = "";
    },
  },
};
</script>
<style scoped>
.quality_inspection {
  /* margin-left: 3.6rem; */
  padding: 1.82rem 0.4rem 0.4rem 0.4rem;
}

.quality_inspection >>> .el-collapse-item__wrap {
  position: fixed;
  width: -webkit-fill-available;
  z-index: 222 !important;
}

.middle-table {
  z-index: 1;
}

.page-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  height: 80px;
  background: #fff;
  width: 100%;
  z-index: 2;
}

.pagination-style {
  padding-top: 15px;
  text-align: right;
}

.search .el-form-item {
  margin-bottom: 0rem !important;
}
.el-drawer__wrapper >>> .el-drawer {
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/quality_inspection/QualityInspection.vue